import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import BaseLayer from "../core/BaseLayer";
import LineModels from "./models";
export default class LineLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'LineLayer');
    _defineProperty(this, "enableShaderEncodeStyles", ['stroke', 'offsets', 'opacity', 'thetaOffset']);
    //注意顺序 4+2+1+1
    _defineProperty(this, "arrowInsertCount", 0);
    _defineProperty(this, "defaultSourceConfig", {
      data: [{
        lng1: 100,
        lat1: 30.0,
        lng2: 130,
        lat2: 30
      }],
      options: {
        parser: {
          type: 'json',
          x: 'lng1',
          y: 'lat1',
          x1: 'lng2',
          y1: 'lat2'
        }
      }
    });
  }
  buildModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const shape = _this.getModelType();
      _this.layerModel = new LineModels[shape](_this);
      yield _this.initLayerModels();
    })();
  }
  getDefaultConfig() {
    const type = this.getModelType();
    const defaultConfig = {
      line: {},
      linearline: {},
      simple: {},
      wall: {},
      arc3d: {
        blend: 'additive'
      },
      arc: {
        blend: 'additive'
      },
      greatcircle: {
        blend: 'additive'
      },
      tileLine: {},
      earthArc3d: {},
      flowline: {},
      arrow: {}
    };
    return defaultConfig[type];
  }
  getModelType() {
    var _shapeAttribute$scale;
    if (this.layerType) {
      return this.layerType;
    }
    const shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');
    const shape = shapeAttribute === null || shapeAttribute === void 0 || (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field;
    return shape || 'line';
  }
  processData(filterData) {
    // simple line 在接受 multiPolygon 的数据进行绘制的时候需要对数据进行拆解
    if (this.getModelType() !== 'simple') {
      return filterData;
    }
    const dataArray = [];
    filterData.map(data => {
      if (Array.isArray(data.coordinates) && Array.isArray(data.coordinates[0]) && Array.isArray(data.coordinates[0][0])) {
        const object = _objectSpread({}, data);
        data.coordinates.map(d => {
          dataArray.push(_objectSpread(_objectSpread({}, object), {}, {
            coordinates: d
          }));
        });
      } else {
        dataArray.push(data);
      }
    });
    return dataArray;
  }
}